module.exports = __webpack_public_path__ + "static/media/1018403.edd66005.jpg";